import {
    List as UiList,
    ListItemButton as UiListItemButton,
    Tooltip as UiTooltip,
    Typography,
} from "@mui/material"
import { styled } from "@mui/material/styles"

import { KeyboardArrowUpIcon } from "@l2r-front/l2r-icons"

type StyledListItemButtonProps = {
    isDisabled?: boolean,
    isSelected?: boolean,
}

export const ListItemButton = styled(UiListItemButton, {
    shouldForwardProp: (prop) => prop !== "isDisabled" && prop !== "isSelected",
})<StyledListItemButtonProps>(({ isDisabled = false, isSelected = false, theme }) => {

    const border = isSelected ? `2px solid ${theme.palette["primary"].main}`
        : isDisabled ? `1px solid ${theme.palette["action/disabledBackground"].main}`
            : `1px solid ${theme.palette.divider}`

    return ({
        "&:hover": {
            backgroundColor: isDisabled ? `${theme.palette["action/disabledBackground"].main} !important`
                : `${theme.palette["action/hover"].main} !important`,
        },
        "& > span": {
            marginLeft: theme.spacing(6),
        },
        "&:active": {
            backgroundColor: isDisabled && `${theme.palette["action/disabledBackground"].main} !important`,
        },
        backgroundColor: isDisabled ? `${theme.palette["action/disabledBackground"].main} !important`
            : `${theme.palette["common/white_states"].main} !important`,
        border: border,
        borderRadius: 12,
        boxSizing: "border-box",
        color: isDisabled && theme.palette["action/disabled"].main,
        cursor: isDisabled ? "default" : "pointer",
        display: "flex",
        fontSize: isSelected ? theme.typography["Desktop & Mobile/Heading/H3"].fontSize : theme.typography["Desktop & Mobile/Body/Regular"].fontSize,
        fontWeight: isSelected ? theme.typography["Desktop & Mobile/Heading/H3"].fontWeight : theme.typography["Desktop & Mobile/Body/Regular"].fontWeight,
        justifyContent: "space-between",
        height: 46,
        marginBottom: theme.spacing(3),
        opacity: isDisabled && "1 !important",
        padding: theme.spacing(1, 4),
        width: "100%",
    })
})

type StyledLabelProps = {
    isDisabled?: boolean,
    isSelected?: boolean,
    hasPaddingLeft?: boolean,
}

export const Label = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "isDisabled" && prop !== "isSelected" && prop !== "hasPaddingLeft",
})<StyledLabelProps>(({ isDisabled = false, hasPaddingLeft = false, isSelected = false, theme }) => ({
    color: isDisabled && theme.palette["action/disabled"].main,
    marginLeft: hasPaddingLeft && "8%",
    marginRight: "auto",
    fontSize: isSelected ? theme.typography["Desktop & Mobile/Heading/H3"].fontSize : theme.typography["Desktop & Mobile/Body/Regular"].fontSize,
    fontWeight: isSelected ? theme.typography["Desktop & Mobile/Heading/H3"].fontWeight : theme.typography["Desktop & Mobile/Body/Regular"].fontWeight,
}))
export const Tooltip = styled(UiTooltip)(() => ({
    marginLeft: "auto",
    marginRight: "6%",
}))

export const List = styled(UiList)(({ theme }) => ({
    marginLeft: theme.spacing(6),
}))

export const InfoItemButton = styled(ListItemButton)(({ selected, theme }) => ({
    border: `2px solid ${selected ? theme.palette["primary"].main : theme.palette["component/input/enabled/border"].main}`,
    height: 46,
    padding: theme.spacing(1, 4),

    "& > p": {
        margin: 0,
    },
}))

type StyledArrowIconProps = {
    isOpen?: boolean,
}

export const ArrowIcon = styled(KeyboardArrowUpIcon, {
    shouldForwardProp: (prop) => prop !== "isOpen",
})<StyledArrowIconProps>(({ isOpen = false, theme }) => ({
    color: theme.palette["common/black_states"].main,
    marginLeft: theme.spacing(3),
    transform: !isOpen && "rotate(180deg)",
}))